"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpLinkLibrary = void 0;
var HelpLinkLibrary = /** @class */ (function () {
    function HelpLinkLibrary() {
        this.language = '';
        this.helpToken = '';
        this.edition = '';
        this.version = '';
        this.platform = '';
        this.build = '';
        this.anchor = '';
    }
    /**
     * Method to set the language abbreviation string to be converted and used as part of a help url.
     * @param {string} language
     */
    HelpLinkLibrary.prototype.setLanguage = function (language) {
        this.language = language;
    };
    /**
     * Set the needed paramaters of language, edition, version, category (also referened as a help token), optional platform,
     * optional build, and optional anchor strings for generating a helpdoc page url. A build paramater of undefined or empty string
     * needs to be provided if the anchor paramater is used but the build paramater is not.
     * @param {string} langauge
     * @param {string} edition
     * @param {string} version
     * @param {string} category
     * @param {string} platform
     * @param {string} build
     * @param {string} anchor
     */
    HelpLinkLibrary.prototype.setHelpUrl = function (langauge, edition, version, category, platform, build, anchor) {
        this.helpToken = category;
        this.language = langauge;
        this.edition = edition;
        this.version = version;
        if (platform !== undefined) {
            this.platform = platform;
        }
        if (build !== undefined) {
            this.build = build;
        }
        if (anchor !== undefined) {
            this.anchor = anchor;
        }
    };
    /**
     * This method will default to en-us if no string is set via the set string method.
     * @returns {string} Returns the converted language string given an abbreviated string provided in the setLanguage method.
     */
    HelpLinkLibrary.prototype.getLanguage = function () {
        if (this.language === '' || this.language === undefined) {
            return 'en-us';
        }
        var lowerLang = this.language.toLocaleLowerCase();
        var retval;
        if (lowerLang.length > 2 && lowerLang.includes('_')) {
            retval = lowerLang.replace('_', '-');
        }
        else if (lowerLang.includes('gb')) {
            retval = 'en-gb';
        }
        else if (lowerLang.includes('en')) {
            retval = 'en-us';
        }
        else if (lowerLang.includes('de')) {
            retval = 'de-de';
        }
        else if (lowerLang.includes('es')) {
            retval = 'es-es';
        }
        else if (lowerLang.includes('fr')) {
            retval = 'fr-fr';
        }
        else if (lowerLang.includes('it')) {
            retval = 'it-it';
        }
        else if (lowerLang.includes('ja')) {
            retval = 'ja-jp';
        }
        else if (lowerLang.includes('ko')) {
            retval = 'ko-kr';
        }
        else if (lowerLang.includes('pt')) {
            retval = 'pt-br';
        }
        else if (lowerLang.includes('tw')) {
            retval = 'zh-tw';
        }
        else if (lowerLang.includes('zh')) {
            retval = 'zh-cn';
        }
        else {
            retval = 'en-us';
        }
        return retval;
    };
    /**
     * Validate that the provided string gives a valid URL.
     * @returns {boolean} Returns whether the string is a valid URL.
     */
    HelpLinkLibrary.prototype.validateUrl = function (providedStr) {
        var pattern = new RegExp('^(https?:\\/\\/)?' +
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
            '((\\d{1,3}\\.){3}\\d{1,3}))' +
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
            '(\\?[;&a-z\\d%_.~+=-]*)?' +
            '(\\#[-a-z\\d_]*)?$', 'i');
        return !!pattern.test(providedStr);
    };
    /**
     * If no values are provided in setHelpUrl then the default return value will be https://www.tableau.com
     * @returns {string} Return a generated help url.
     */
    HelpLinkLibrary.prototype.getHelpUrl = function () {
        var retval = 'https://www.tableau.com/';
        var prepStr = 'prep';
        var phoenixStr = 'tableau-mobile-phoenix';
        if (this.edition === phoenixStr) {
            retval += this.language +=
                '/app/' + this.helpToken + '?edition=' + this.edition + '&lang=' + this.language + '&version=' + this.version;
        }
        else if (this.edition === prepStr) {
            retval +=
                this.language +
                    '/app/' +
                    this.helpToken +
                    '?build=' +
                    this.build +
                    '&edition=' +
                    this.edition +
                    '&lang=' +
                    this.language +
                    '&platform=' +
                    this.platform +
                    '&version=' +
                    this.version;
        }
        else if (this.edition.includes('server') || this.edition.includes('online')) {
            retval +=
                this.language +
                    '/app/' +
                    this.helpToken +
                    '?edition=' +
                    this.edition +
                    '&lang=' +
                    this.language +
                    '&platform=' +
                    this.platform +
                    '&version=' +
                    this.version;
        }
        if (this.anchor !== undefined && this.anchor.length > 0) {
            retval += '&anchor=' + this.anchor;
        }
        if (!this.validateUrl(retval)) {
            throw new Error('Invalid URL.');
        }
        return retval;
    };
    return HelpLinkLibrary;
}());
exports.HelpLinkLibrary = HelpLinkLibrary;
//# sourceMappingURL=HelpLinkLibrary.js.map